<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="mdi-package-variant"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1">
        <v-col cols="8" class="content_category rounded-lg">
          <v-row class="mx-3">
            <v-col cols="6"  class="set-height-cols">

              <v-select
                  background-color="#EDF2F7"
                  filled
                  item-text="name"
                  item-value="id"
                  v-model="production.brand_id"
                  :items="brands"
                  label="Chọn nhãn hàng"
              ></v-select>
            </v-col>
            <v-col cols="6" class="set-height-cols">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Tên"
                  v-model="production.name"
                  placeholder="Nhập tên sản phẩm"
              ></v-text-field>
            </v-col>
            <v-col cols="12" >
              <v-textarea
                  background-color="#EDF2F7"
                  filled
                  label="Mô tả ngắn"
                  v-model="production.short_description"
                  placeholder="Nhập mô tả ngắn"
              >
              </v-textarea>
            </v-col>
            <v-col cols="12" >
              <ck-content  class="production" :content="production.description" @getData="value => production.description = value" @getSeo="triggerSeo"/>
            </v-col>
            <v-col cols="6" class="set-height-cols">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Slug"
                  @blur="triggerSeo"
                  placeholder="Nhập tên slug"
                  v-model="production.slug"
              ></v-text-field>
            </v-col>
<!--            <v-col cols="6" class="set-height-cols">-->
<!--              <v-checkbox-->
<!--                  :label="'Phụ kiện'"-->
<!--                  v-model="production.is_accessory"-->
<!--              ></v-checkbox>-->
<!--            </v-col>-->
<!--            nhap xuất xứ-->
            <v-col cols="6" class="set-height-cols">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Xuất xứ"
                  placeholder="Nhập tên xuất xứ"
                  v-model="production.made_in"
              ></v-text-field>
            </v-col>
<!--            nhap thời gian bảo hành-->
            <v-col cols="6" class="set-height-cols">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Thời gian bảo hành"
                  placeholder="Nhập thời gian bảo hành"
                  v-model="production.warranty"
              ></v-text-field>
            </v-col>
<!--            nhap sku-->
            <v-col cols="6" class="set-height-cols">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="SKU"
                  v-model="production.sku"
                  placeholder="Nhập SKU"
              ></v-text-field>
            </v-col>
            <!--            nhap Serial number-->
            <v-col cols="6" class="set-height-cols">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Serial number"
                  v-model="production.serial_number"
                  placeholder="Nhập Serial number"
              ></v-text-field>
            </v-col>
            <!--            nhap so luong-->
            <v-col cols="6" class="set-height-cols">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Số lượng"
                  v-model="production.quantity"
                  placeholder="Nhập số lượng"
              ></v-text-field>
            </v-col>
            <!--            trang thai kho-->
            <v-col cols="6" class="set-height-cols">
              <v-select
                  disabled
                  background-color="#EDF2F7"
                  filled
                  :items="warehouse"
                  item-value="value"
                  item-text="text"
                  label="Trạng thái kho"
              ></v-select>
            </v-col>
            <!--            nhap gia-->
            <v-col cols="6" class="set-height-cols">
              <vuetify-money
                class="vuetify-money"
                v-model="production.price"
                label="Giá (vnđ)"
                placeholder="Nhập giá tiền"
                background-color="#EDF2F7"
                v-bind:options="optionsInputPrice"
              />
            </v-col>
            <!--            nhap gia khuyen nghi-->
            <v-col cols="6" class="set-height-cols">
              <vuetify-money
                class="vuetify-money"
                v-model="production.price_recommendation"
                label="Giá khuyến nghị (vnđ)"
                placeholder="Nhập giá tiền"
                background-color="#EDF2F7"
                v-bind:options="optionsInputPrice"
              />
            </v-col>
            <!--           gia discount-->
            <v-col cols="6" class="set-height-cols">
              <v-text-field
                  background-color="#EDF2F7"
                  filled
                  label="Giá Discount (vnđ)"
                  placeholder="Nhập giá discount"
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="set-height-cols">
              <v-text-field
                background-color="#EDF2F7"
                filled
                label="Độ ưu tiên"
                v-model="production.order"
                placeholder="Độ ưu tiên"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="set-height-cols">
              <v-autocomplete
                  background-color="#EDF2F7"
                  filled
                  item-value="id"
                  item-text="name"
                  clearable
                  :items="compare_category"
                  v-model="production.compare_category_id"
                  label="Chọn category so sánh"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="set-height-cols multi-select">
                <v-autocomplete
                    background-color="#EDF2F7"
                    filled
                    :menu-props="{ maxHeight: '400' }"
                    item-value="id"
                    item-text="name"
                    multiple
                    :items="categories"
                    v-model="production.category_buy_together"
                    label="Chọn category đi kèm"
                ></v-autocomplete>
            </v-col>
<!--            nhap parent-->
            <v-col cols="12" class="set-height-cols multi-select">
              <v-autocomplete
                  background-color="#EDF2F7"
                  filled
                  item-value="id"
                  item-text="name"
                  clearable
                  :items="productions"
                  v-model="production.products_customers_interested"
                  label="Khách hàng quan tâm"
                  multiple
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" class="set-height-cols multi-select">
              <v-autocomplete
                  background-color="#EDF2F7"
                  filled
                  item-value="id"
                  item-text="name"
                  clearable
                  :items="posts"
                  v-model="production.post_ids"
                  label="Bài viết liên quan"
                  multiple
              ></v-autocomplete>
            </v-col>

          </v-row>
        </v-col>
        <v-col cols="3" class="content_category rounded-lg ml-3 pa-0 ma-0">
          <div >
            <h4 class="mb-3 mt-3 ml-3">Category</h4>
            <v-divider></v-divider>
            <div
                class="overflow-y-auto pa-0 ma-0"
                id="scroll-target"
                 style="max-height: 900px">
              <div class="mx-3" v-scroll.#scroll-target="onScroll" style="height: 900px">
                <v-radio-group
                    v-model="production.category_id"
                    column
                >
                  <div v-for="category in categories"  v-bind:key="category.id">
                    <v-row >
                      <v-col cols="10" class="d-flex align-center">
                        <v-checkbox
                            @change="checkedCategory(category.id)"

                            :label="category.name"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="2" class=" d-flex align-end">
                        <v-radio
                            :value="category.id"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </div>
                </v-radio-group>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="8" class="content_category1 mt-3 rounded-lg " >
          <v-col cols="12">
            <v-file-input
                multiple
                label="Ảnh"
                placeholder="Tải ảnh lên"
                prepend-icon="mdi-camera"
                @change="fileSelected"
            ></v-file-input>
          </v-col>
          <v-radio-group
              v-model="isMain"
              row
          >
            <v-col cols="3" v-for="(img,index) in list_imgs" :key="img.id"
                   draggable="true"
                   @dragstart="dragStart(index, $event)"
                   @dragover.prevent
                    @dragend="dragEnd"
                   @drop="dragFinish(index, $event)"
            >
              <v-row >
                <v-col cols="12" class="justify-center box-image-media">
                  <v-img
                      height="150"
                      :src="img.url_image"
                      style=""
                  ></v-img>
                  <v-text-field
                    filled
                    background-color="#EDF2F7"
                    v-model="img.link"
                    placeholder="Nhập link"
                  ></v-text-field>
                  <v-text-field
                    filled
                    background-color="#EDF2F7"
                    v-model="img.text"
                    placeholder="Nhập nội dung"
                  ></v-text-field>
                  <v-text-field
                    filled
                    background-color="#EDF2F7"
                    v-model="img.link_text"
                    placeholder="Nhập link nội dung"
                  ></v-text-field>
                  <v-text-field
                    filled
                    background-color="#EDF2F7"
                    v-model="img.alt_image"
                    placeholder="Nhập alt"
                  ></v-text-field>
                </v-col>
                <v-col cols="6" class="d-flex justify-start ">
                  <v-radio
                      class="d-flex align-center mt-n3"
                      :value="index"
                  ></v-radio>

                </v-col>

                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                      @click="clearImg(index)"
                      x-small
                      outlined
                      fab
                      color="red"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-radio-group>
        </v-col>
        <v-col cols="3" class="content_category1 rounded-lg ml-3 mt-3">
          <div class="mx-2">
            <h4 class="mb-2">Project tags</h4>
            <v-divider></v-divider>
            <div>
              <v-autocomplete
                  v-model="list_tag_id"
                  :items="list_tags"
                  item-value="id"
                  item-text="name"
                  chips
                  label="Tags"
                  multiple
                  outlined
              ></v-autocomplete>
            </div>
          </div>
        </v-col>
        <v-col cols="8" class="content_category mt-3 rounded-lg">
          <v-row class="mx-3">
            <v-col cols="3" class="d-flex mt-5">
              <h4>Thông số kỹ thuật</h4>
            </v-col>
            <v-col cols="8" class="d-flex justify-end">
              <v-row class="d-flex justify-end">
                <v-col cols="8">
                  <v-autocomplete
                      outlined
                      dense
                      item-value="id"
                      item-text="name"
                      color="#0097A7"
                      :items="group_category"
                      @change="getListAttribute"
                      label="Chọn nhóm thuộc tính"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="3">
                  <v-btn
                    color="info"
                    @click="addTSKT()"
                  >
                    Thêm
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12"  >
              <div v-for="(item, index) in tskt" :key="index">
                <v-row class="ma-0 pa-0">
                  <v-col cols="5" class="ma-0 pa-0 pr-1">
                    <v-text-field
                        v-model="item.name"
                        background-color="#EDF2F7"
                        filled
                        label="Tên thuộc tính"
                        placeholder="Nhập tên thuộc tính"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5" class="ma-0 pa-0">
                    <v-text-field
                        v-model="item.value"
                        background-color="#EDF2F7"
                        filled
                        label="Thông số"
                        placeholder="Nhập thông số"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="ma-0 pa-0">
                    <v-btn
                        class="ma-2"
                        outlined
                        large
                        color="indigo"
                        @click="clearBlock(index)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </div>
            </v-col>
            <v-col cols="6">
              <v-file-input
                  label="Ảnh thông số kỹ thuật"
                  placeholder="Tải ảnh lên"
                  prepend-icon="mdi-camera"
                  @change="fileSelectedTSKT"
              ></v-file-input>
            </v-col>
            <v-col cols="6" v-for="(img, index) in list_img_attribute" :key="index">
              <v-img
                  :src="img"
                  contain
                  aspect-ratio="1.7"
              ></v-img>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row class="mx-3">
            <v-col>
              <h4>No-index</h4>
              <div>
                <v-switch
                    v-model="production.no_index"
                ></v-switch>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="8" class="content_category mt-3 rounded-lg">
          <v-row class="mx-3">
            <v-col cols="3" class="d-flex mt-5">
              <h4>Quà tặng</h4>
            </v-col>
            <v-col cols="12"  >
              <v-row class="ma-0 pa-0">
                <v-col cols="4" class="ma-0 pa-0 pr-1">
                  <v-autocomplete
                      background-color="#EDF2F7"
                      filled
                      item-text="name"
                      item-value="id"
                      v-model="production.package_id"
                      :items="packages"
                      clearable
                      label="Chọn gói quà tặng"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="4" class="ma-0 pa-0 pr-1">
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        background-color="#EDF2F7"
                        filled
                        readonly
                        v-model="computedPromotionStartDateFormatted"
                        label="Ngày bắt đầu"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="production.promotion_start_date"
                      no-title
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="4" class="ma-0 pa-0">
                  <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        background-color="#EDF2F7"
                        filled
                        readonly
                        v-model="computedPromotionEndDateFormatted"
                        label="Ngày kết thúc"
                        append-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="production.promotion_end_date"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="8" class="content_category mt-3 rounded-lg">
          <v-row class="mx-3">
            <v-col cols="3" class="d-flex mt-5">
              <h4>SEO</h4>
            </v-col>
              <v-col cols="12">
                  <v-text-field
                    background-color="#EDF2F7"
                    filled
                      @blur="triggerSeo"
                    label="SEO Title"
                    placeholder="Nhập SEO Title"
                    v-model="production.meta_title"
                  ></v-text-field>
              </v-col>
              <v-col cols="12">
                  <v-textarea
                    class="content-textarea"
                    background-color="#EDF2F7"
                    filled
                      @blur="triggerSeo"
                    label="SEO Description"
                    placeholder="Nhập mô tả"
                    v-model="production.meta_description"
                  >
                  </v-textarea>
              </v-col>
          </v-row>
        </v-col>

        <seo 
          @getKeywords="getKeywords"
          :trigger_seo="count_trigger_seo"
          :text_seo="text_seo"
          :meta_title="production.meta_title"
          :content="production.description"
          :slug="production.slug"
          :meta_description="production.meta_description"
        />
        <v-col cols="8" class="text-center">
          <v-btn
              @click="save()"
              color="primary"
              width="180"
          >
            Lưu
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import {GET_LIST_NEWS_SEARCH} from '@/store/modules/news'
import {GET_LIST_CATEGORY, GET_DETAIL_CATEGORY} from '@/store/modules/category'
import {GET_LIST_BRAND} from '@/store/modules/brand'
import {UPLOAD_PRODUCT_IMAGE, SAVE_PRODUCT, GET_LIST_PRODUCT_SEARCH} from '@/store/modules/production'
import {GET_LIST_PACKAGES} from '@/store/modules/promotion_gift'
import {GET_LIST_TAG} from '@/store/modules/tag'
import {mapGetters} from "vuex";
import CkContent from "@/components/ck-content"
import Seo from "@/components/seo"
import { replaceCkContent } from '@/utils/helpers'

import Vue from "vue";
import VuetifyMoney from "vuetify-money";
Vue.use(VuetifyMoney);

export default {
  components: {
    CkContent,
    Seo
  },
  data() {
    return {
      count_trigger_seo: 0,
      offsetTop: 0,
      optionsInputPrice: {
        locale: "en-EN",
        prefix: "",
        suffix: "",
        length: 15,
        precision: 0,
      },
      group_category:[],
      compare_category: [],
      radio: null,
      list_imgs: [],
      isMain: false,
      list_img_attribute: [],
      list_tags: [],
      list_tag_id: [],
      items: ['Hàng bán chạy', 'Gía rẻ', 'Hàng bán chạy1', 'Hàng bán chạy2'],
      value: ['Hàng bán chạy', 'Gía rẻ', 'Hàng bán chạy1', 'Hàng bán chạy2'],
      warehouse: [
        {
          value:0,
          text: 'Còn hàng'
        },
        {
          value:1,
          text: 'Hết hàng'
        }
      ],
      page: "Quản lý sản phẩm",
      production: {
        name:'',
        brand_id: null,
        parent_id: null,
        products_customers_interested: null,
        short_description:'',
        sku:'',
        serial_number:'',
        quantity:0,
        order: null,
        slug:'',
        description:'',
        category_ids:[],
        list_attribute:[],
          F: [],
        price:0,
        list_tag:[],
        compare_category_id: null,
        category_id: null,
        list_media:[],
        list_media_attribute:[],
        category_buy_together:[],
        package_id: null,
        promotion_start_date: null,
        promotion_end_date: null,
        made_in: null,
        warranty: null,
        is_accessory: 0,
        meta_title: '',
        meta_description: '',
        meta_keyword: '',
        post_ids: [],
        no_index: false
      },
      tskt:[],
      block_tskt:{
        name:'',
        value:''
      },
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true
        },
        {
          text: "Quản lý sản phẩm",
          disabled: true,
        },
        {
          text: "Thêm sản phẩm",
          disabled: true,
        },
      ],
      errors : 0,
      text_seo: "",
      SEO: [],
      menu1:false,
      menu2:false,
      dragging: -1
    };
  },
  computed:{
    ...mapGetters({
      posts: "newSearches",
      productions: "productionSearches",
      categories: "categories",
      category: "categoryDetail",
      brands: "brands",
      tags: "tags",
      seos: "seos",
      packages: "packages",
    }),
    computedPromotionStartDateFormatted () {
      return this.formatDate(this.production.promotion_start_date);
    },
    computedPromotionEndDateFormatted () {
      return this.formatDate(this.production.promotion_end_date);
    }
  },
  watch:{
    isMain(val){
      // this.production.list_media[val].isMain = true
      this.list_imgs[val].isMain = true
    },
    tags(val){
      if(val) {
        const _this = this
        val.forEach(el => {
          _this.list_tags.push({
            id: el.id,
            name: el.name,
          })
        })
      }
    },
    category(val){
      if(val && val.list_attribute) {
        val.list_attribute.forEach(el => {
          let data = {
            name: el.name,
            value: ''
          }

          this.tskt.push(data)
        })
      }
    },
    categories(val){
      if (val){
        val.forEach(el => {
          if (el.is_comparable == 1) {
            this.compare_category.push(el)
          }
          if (el.is_group_template == 1) {
            this.group_category.push(el)
          }
        })
      }
    }
  },
  async created(){
    await this.$store.dispatch(`${GET_LIST_NEWS_SEARCH}`);
    await this.$store.dispatch(`${GET_LIST_PRODUCT_SEARCH}`, { product_type: 0});
    await this.$store.dispatch(`${GET_LIST_CATEGORY}`);
    await this.$store.dispatch(`${GET_LIST_BRAND}`);
    await this.$store.dispatch(`${GET_LIST_TAG}`);
    await this.$store.dispatch(`${GET_LIST_PACKAGES}`);
  },
  mounted() {

  },
  methods:{
    removeItemAt(index) {
      this.list_imgs.splice(index, 1);
    },
    dragStart(which, ev) {
      ev.dataTransfer.setData('Text', this.id);
      ev.dataTransfer.dropEffect = 'move'
      this.dragging = which;
    },
    // dragEnter(ev) {
    //   /*
    //   if (ev.clientY > ev.target.height / 2) {
    //     ev.target.style.marginBottom = '10px'
    //   } else {
    //     ev.target.style.marginTop = '10px'
    //   }
    //   */
    // },
    // dragLeave(ev) {
    //   /*
    //   ev.target.style.marginTop = '2px'
    //   ev.target.style.marginBottom = '2px'
    //   */
    // },
    dragEnd() {
      this.dragging = -1
    },
    dragFinish(to, ev) {
      this.moveItem(this.dragging, to);
      ev.target.style.marginTop = '2px'
      ev.target.style.marginBottom = '2px'
    },
    moveItem(from, to) {
      if (to === -1) {
        this.removeItemAt(from);
      } else {
        this.list_imgs.splice(to, 0, this.list_imgs.splice(from, 1)[0]);
      }
    },

    onScroll (e) {
      this.offsetTop = e.target.scrollTop
    },
    save(){
      const _this = this;
      //list tags
      this.list_tag_id.forEach(id => {
       let tag = _this.list_tags.find(el => el.id == id)
        _this.production.list_tag.push({
          id:tag.id,
          name:tag.name,
        })
      })
      let data_product = {
          name:this.production.name,
          brand_id: this.production.brand_id,
          short_description:this.production.short_description,
          sku:this.production.sku,
          serial_number:this.production.serial_number,
          quantity:this.production.quantity,
          slug:this.production.slug,
          description:replaceCkContent(this.production.description),
          category_ids:JSON.stringify(this.production.category_ids),
          list_attribute:JSON.stringify(this.tskt),
          list_media: JSON.stringify(this.list_imgs),
          price:this.production.price,
          price_recommendation: this.production.price_recommendation,
          list_tag:JSON.stringify(this.production.list_tag),
          compare_category_id: this.production.compare_category_id,
          category_id: this.production.category_id,
          list_media_attribute:JSON.stringify(this.production.list_media_attribute),
          category_buy_together:JSON.stringify(this.production.category_buy_together),
          package_id: this.production.package_id,
          promotion_start_date: this.production.promotion_start_date,
          promotion_end_date: this.production.promotion_end_date,
          parent_id: this.production.parent_id,
          made_in: this.production.made_in,
          warranty: this.production.warranty,
          is_accessory: 0,
          products_customers_interested:JSON.stringify(this.production.products_customers_interested),
          meta_title: this.production.meta_title,
          meta_description: this.production.meta_description,
          meta_keyword: this.production.meta_keyword,
          order: this.production.order,
          post_ids: this.production.post_ids,
        no_index: this.production.no_index,
      }
      this.$store.dispatch(`${SAVE_PRODUCT}`, data_product).then((data)=>{
        if(data.data.status == 1){
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          })
          this.$router.push('/manage_productions/production');
        }else{
          alert(data.data.errors)
        }
      })
    },
    clearImg(index){
      this.list_imgs.splice(index, 1)
      this.production.list_media.splice(index, 1)
      this.$forceUpdate()
    },
      addTSKT(){
        this.tskt.push({
          key: this.block_tskt.name,
          value: this.block_tskt.value,
        })
      },
      clearBlock(i){
        this.tskt.splice(i, 1)
        this.$forceUpdate()
      },
    getListAttribute(event){
      this.$store.dispatch(`${GET_DETAIL_CATEGORY}`, event)
    },
    checkedCategory(id){
      if (this.production.category_ids.indexOf(id) != -1){
        this.production.category_ids = this.production.category_ids.filter(item =>{
          return item != id
        })
      }
      else {
        this.production.category_ids.push(id)
      }
    },
    fileSelected(event){
      const _this = this;
      if (!event) {
        this.production.list_media = []
      } else {
        // this.production.list_media = []
        let formData = new FormData();
        event.forEach(element => {
          formData.append("upload", element);
          formData.append("type", "products");
          _this.$store.dispatch(`${UPLOAD_PRODUCT_IMAGE}`,formData).then((data) => {
            data.data.data.forEach(el => {
              _this.list_imgs.push({
                id: el.media_id,
                url_image: el.url,
                url: el.path,
                link: "",
                text: "",
                link_text: "",
                alt_image: "",
              })
              // let data_media = {
              //   id: el.media_id,
              //   url: el.url,
              // }
              // _this.list_imgs.push({
              //   id: el.media_id,
              //   url: el.url,
              // })
              // _this.production.list_media.push(data_media);
            })
          })
        })
      }
    },
    fileSelectedTSKT(event){
      const _this = this;
      if (!event) {
        this.production.list_media_attribute = [];
      }
      this.list_img_attribute = [];
      let img = URL.createObjectURL(event);
      this.list_img_attribute.push(img)
      this.production.list_media_attribute = [];
      let formData = new FormData();
      formData.append("upload", event);
      formData.append("type", "products");
      this.$store.dispatch(`${UPLOAD_PRODUCT_IMAGE}`, formData).then((data) => {
        data.data.data.forEach(element => {
          let data = {
            id:element.media_id,
            url:element.url,
          }

          _this.production.list_media_attribute.push(data)
        })
      })
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-');
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
    },
    triggerSeo(){
      this.count_trigger_seo++;
    },
    getKeywords(keywords){
      console.log(keywords);
      this.production.meta_keyword = keywords
    }
  }
};
</script>
<style lang="scss">
.vuetify-money .v-text-field{
  padding:0px;
  margin: 0px;;
}
.vuetify-money .v-text-field > .v-input__control > .v-input__slot{
  min-height: 56px;
  padding: 0 12px;
}
.vuetify-money .v-text-field .v-label--active{
  top: 18px;
}
.vuetify-money .v-text-field .v-label--active + input{
  position: relative;
  top:10px;
}
.set-height-cols {
  max-height: 80px;
}
.content_category1 {
  background: #ffffff !important;
}
.content_category {
  background: #ffffff !important;
  .v-input__control {

  }
  .content-textarea .v-input__control {
    height: 165px!important;
  }
  .v-input--checkbox .v-input__control {
    height: 20px !important;
  }
}
.production .ck-editor__main .ck-editor {
  height: 140px;

}
.multi-select .v-select__selections{
  flex-wrap: inherit;
  overflow: hidden;
}
.multi-select .v-select__selection--comma{
  display: inline-table;
}
</style>